import * as React from "react";
import { Checkbox } from "../ui/checkbox";
import { Label } from "../ui/label";
import { cn } from "../../lib/utils";

interface CheckboxWithLabelProps {
  id: string;
  label: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
}

export const CheckboxWithLabel = ({
  id,
  label,
  checked,
  defaultChecked,
  onCheckedChange,
  disabled = false,
  className,
  labelClassName,
}: CheckboxWithLabelProps): React.ReactElement => {
  return (
    <div
      className={cn(
        "flex items-center space-x-2 cursor-pointer hover:cursor-pointer",
        className,
      )}
    >
      <Checkbox
        id={id}
        checked={checked}
        defaultChecked={defaultChecked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
      />
      <Label
        htmlFor={id}
        className={cn(
          "text-sm font-normal leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer",
          disabled && "opacity-50",
          labelClassName,
        )}
      >
        {label}
      </Label>
    </div>
  );
};
